import vaultLoading from "../../assets/Vault-Logo-Animation.gif";

const VaultSpinner = () => {
  return (
    <div>
      <img src={vaultLoading} alt="Vault Loading Animation..." />
    </div>
  );
};

export default VaultSpinner;
